<template>
    <div class="card mB-10">
        <div class="card-header">
            <i class="far fa-empty-set"></i> No additional addons
        </div>
        <div class="card-body">
            <p class="mB-0">The selection made has no additional addons to be offered.</p>
        </div>
    </div>
</template>